/** @format */
import { Context, createContext } from 'react';

import { User } from '@toucan/common/services/user/types';

import { MarketCode } from '@toucan/client/global/market';
import { Model } from '@toucan/client/global/model';
import { SavedProduct } from '@toucan/client/global/product';

export type UserContextProps = {
    user?: User;
    isLoggedIn: boolean;
    geolocatedMarket?: MarketCode;
    getUser: () => Promise<void>;
    isSavedProductsLoading: boolean;
    isSavedModelsLoading: boolean;
    getSavedProducts: () => void;
    isSavedProduct: (id: number | undefined) => boolean;
    addSavedProduct: (id: number) => void;
    removeSavedProduct: (id: number) => void;
    savedProducts: SavedProduct[];
    isSavedModel: (id: number) => boolean;
    getSavedModels: () => void;
    addSavedModel: (id: number) => void;
    removeSavedModel: (id: number) => void;
    savedModels: Model[];

    /**
     * If an initial request to get the user information
     * has taken place
     */
    isInitialised: boolean;
};

export const UserContext: Context<UserContextProps> = createContext(
    {} as UserContextProps
);

UserContext.displayName = 'UserContext';
